import React from 'react';

import MemorySharingShareLink from './ShareLink';
import MemorySharingEmail from './Email';

import type { Memory } from '../../types/memory';

const MemorySharing: React.FC<{ memory: Memory }> = ({ memory }) => {
  return (
    <div className="memory-sharing">
      <div className="page-eyebrow">
        Sharing options
      </div>
      <div className="wa-stack wa-gap-xs">
        <MemorySharingShareLink memory={memory} />
        <MemorySharingEmail memory={memory} />
      </div>
    </div>
  );
}

export default MemorySharing;
